import { create } from 'zustand'
import {
  createJSONStorage,
  persist,
  subscribeWithSelector,
} from 'zustand/middleware'

export type SignUpGuestComplete = {
  surveyAvailable: boolean
  signUpCompleteTime: string
  verificationType: 'passport' | 'phone' | null
}

type SignUpGuestCompleteStore = {
  complete: SignUpGuestComplete
  isHydrated: boolean
  actions: {
    updateComplete: (data: SignUpGuestComplete) => void
    updateIsHydrated: () => void
    reset: () => void
  }
}
const initialState = {
  complete: {
    surveyAvailable: false,
    signUpCompleteTime: '',
    verificationType: null,
  },
  isHydrated: false,
}

export const useSignUpGuestCompleteStore = create<SignUpGuestCompleteStore>()(
  subscribeWithSelector(
    persist(
      set => ({
        ...initialState,
        actions: {
          updateComplete: data => {
            set(state => ({
              complete: { ...state.complete, ...data },
            }))
          },
          updateIsHydrated: () => {
            set(() => ({
              isHydrated: true,
            }))
          },
          reset: () => {
            set(initialState)
          },
        },
      }),
      {
        name: 'sign-up-guest-complete',
        storage: createJSONStorage(() => sessionStorage),
        partialize: state => ({
          complete: state.complete,
        }),
      },
    ),
  ),
)
